module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Total hashrate during times when DARI is highest. Orange line means BTC DARI was highest, blue means BCH DARI was highest. \n    ")]), _vm._v("\n\n    7 day rolling average\n    "), _c('hashrate-dari', {
    attrs: {
      "avg": "rate7d"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n    3 day rolling average\n    "), _c('hashrate-dari', {
    attrs: {
      "avg": "rate3d"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n    1 day rolling average\n    "), _c('hashrate-dari', {
    attrs: {
      "avg": "rate1d"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n    12 hour rolling average\n    "), _c('hashrate-dari', {
    attrs: {
      "avg": "rate12h"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n    3 hour rolling average\n    "), _c('hashrate-dari', {
    attrs: {
      "avg": "rate3h"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ccfa81c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/hashdari.vue
// module id = 532
// module chunks = 1